import { FormattedMessage } from "react-intl";
import { useParams } from "react-router-dom";
import { ReactComponent as CancelIcon } from "assets/images/iconsV2/slash-circle-01.svg";
import { ReactComponent as CancelProviderIcon } from "assets/images/iconsV2/user-x-01.svg";
import { useGetShipmentBasic } from "api/queries/shipments/useGetShipmentBasic";
import PropTypes from "prop-types";
import testIds from "constants/testIds";
import ActionButton from "../../common/TopNavV2/TopNavActions/ShipperProviderActions/ActionButton";

interface ICancelMenuProps {
  isQuickRequest: boolean;
  isShipment: boolean;
  isShipmentCancelAndDuplicate: boolean;
  openCancelDialog: (value: boolean) => void;
}

function CancelMenuItem({ isQuickRequest, isShipment, isShipmentCancelAndDuplicate, openCancelDialog }: ICancelMenuProps) {
  const { id } = useParams();
  const { data: shipmentData }: any = useGetShipmentBasic(id!, {
    enabled: !!id && !isQuickRequest,
    refetchOnMount: false,
  });
  const hasApprovedInvoices = shipmentData?.shipment?.approved_invoices > 0;
  const isCancelAndChangeProviderOption = isShipment && isShipmentCancelAndDuplicate;

  const label = isShipment ? (
    isShipmentCancelAndDuplicate ? (
      <FormattedMessage
        id="shipment-quotes.components.cancelRequestBanner.cancelAndChangeProvider"
        defaultMessage="Cancel and change provider"
      />
    ) : (
      <FormattedMessage
        id="shipment-quotes.components.cancelRequestBanner.cancelShipment"
        defaultMessage="Cancel Shipment"
      />
    )
  ) : isQuickRequest ? (
    <FormattedMessage
      id="shipment-quotes.components.cancelRequestBanner.cancelQuickRequest"
      defaultMessage="Cancel Quick Request"
    />
  ) : (
    <FormattedMessage
      id="shipment-quotes.components.cancelRequestBanner.cancelQuoteRequest"
      defaultMessage="Cancel Quote Request"
    />
  );

  if (isShipment && hasApprovedInvoices) return null;

  return (
    <ActionButton
      onClick={() => {
        openCancelDialog(true);
      }}
      icon={
        isCancelAndChangeProviderOption ? (
          <CancelProviderIcon height={16} width={16} />
        ) : (
          <CancelIcon height={16} width={16} />
        )
      }
      testId={testIds.SHIPMENT_DASHBOARD_CANCEL_BUTTON}
      title={<div>{label}</div>}
      isCancelAction
    />
  );
}

CancelMenuItem.propTypes = {
  openCancelDialog: PropTypes.func.isRequired,
  isQuickRequest: PropTypes.bool.isRequired,
  isShipment: PropTypes.bool.isRequired,
};

export default CancelMenuItem;
